import { render, staticRenderFns } from "./CommentAddModal.vue?vue&type=template&id=58fe2df4&scoped=true&"
import script from "./CommentAddModal.vue?vue&type=script&lang=js&"
export * from "./CommentAddModal.vue?vue&type=script&lang=js&"
import style0 from "./CommentAddModal.vue?vue&type=style&index=0&id=58fe2df4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fe2df4",
  null
  
)

export default component.exports